/* Nutrilight homepage (nl-home-* sections): reveal on scroll, product guide tabs, carousel dots.
   Content is visible without JS; the nlh-js class is only added here, so nothing is hidden if this file fails. */
(function () {
  if (window.__nlhInit) return;
  window.__nlhInit = true;
  var doc = document.documentElement;
  doc.classList.add('nlh-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);

  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---- reveal */
  var io = null;
  function reveal(root) {
    var els = $$('.nlh .nlh-rv', root).filter(function (el) { return !el.__nlhRv; });
    els.forEach(function (el) { el.__nlhRv = true; });
    if (reduce || design || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- hero image settle */
  function hero(root) {
    $$('.nlh-hero', root).forEach(function (h) {
      var img = h.querySelector('.nlh-hero-media img');
      var done = function () { requestAnimationFrame(function () { h.classList.add('is-ready'); }); };
      if (!img || img.complete) done(); else { img.addEventListener('load', done, { once: true }); setTimeout(done, 1500); }
    });
  }

  /* ---- product guide tabs */
  function guide(root) {
    $$('[data-nlh-guide]', root).forEach(function (g) {
      if (g.__nlhG) return; g.__nlhG = true;
      var tabs = $$('[role="tab"]', g);
      var panels = $$('[role="tabpanel"]', g);
      if (!tabs.length) return;
      function select(i, focus) {
        tabs.forEach(function (t, j) {
          var on = i === j;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (panels[j]) {
            panels[j].hidden = !on;
            if (on) { panels[j].classList.remove('is-in'); void panels[j].offsetWidth; panels[j].classList.add('is-in'); }
          }
        });
        if (focus) tabs[i].focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          select(i, false);
          if (window.matchMedia('(max-width: 900px)').matches && panels[i]) {
            var r = panels[i].getBoundingClientRect();
            if (r.top > window.innerHeight * 0.75 || r.top < 0) panels[i].scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest' });
          }
        });
        t.addEventListener('keydown', function (e) {
          var k = e.key, n = tabs.length;
          if (k === 'ArrowDown' || k === 'ArrowRight') { e.preventDefault(); select((i + 1) % n, true); }
          else if (k === 'ArrowUp' || k === 'ArrowLeft') { e.preventDefault(); select((i - 1 + n) % n, true); }
          else if (k === 'Home') { e.preventDefault(); select(0, true); }
          else if (k === 'End') { e.preventDefault(); select(n - 1, true); }
        });
      });
      var start = tabs.findIndex ? tabs.findIndex(function (t) { return t.getAttribute('aria-selected') === 'true'; }) : 0;
      select(start < 0 ? 0 : start, false);
    });
  }

  /* ---- carousel dots (mobile bestsellers) */
  function dots(root) {
    $$('[data-nlh-track]', root).forEach(function (track) {
      if (track.__nlhD) return; track.__nlhD = true;
      var wrap = track.parentNode.querySelector('[data-nlh-dots]');
      if (!wrap) return;
      var cards = $$(':scope > *', track);
      wrap.innerHTML = cards.map(function () { return '<i></i>'; }).join('');
      var ds = $$('i', wrap);
      function upd() {
        var x = track.scrollLeft, best = 0, bd = Infinity;
        cards.forEach(function (c, i) { var d = Math.abs(c.offsetLeft - track.offsetLeft - x - 16); if (d < bd) { bd = d; best = i; } });
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) best = cards.length - 1;
        ds.forEach(function (d, i) { d.classList.toggle('is-on', i === best); });
      }
      var t = null;
      track.addEventListener('scroll', function () { if (t) cancelAnimationFrame(t); t = requestAnimationFrame(upd); }, { passive: true });
      upd();
    });
  }

  function init(root) { hero(root); guide(root); dots(root); reveal(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
